//export const baseUrl = 'http://52.14.65.118:4000/'; //Production
//export const baseUrl = 'http://52.42.94.80:4000/'; //Test
export const baseUrl = 'http://18.222.90.78:4000/'; //UstaTunja

export const sessionEndpoint = () => `${baseUrl}sessions`;
export const generalReportsLoanEndpoint = (params, monthly) => {
  if (monthly) {
    return `${baseUrl}general_report_loans/monthly${serialize(params)}`
  } else {
    return `${baseUrl}general_report_loans/${serialize(params)}`
  }
};
export const userTracesEndpoint = params => `${baseUrl}user_traces/${serialize(params)}`;
export const getSystemUsersEndpoint = () => `${baseUrl}users`;
export const getSystemUserProfileEndpoint = () => `${baseUrl}users/me`;
export const updateSystemUserProfileEndpoint = () => `${baseUrl}users/me`;
export const addSystemUsersEndpoint = () => `${baseUrl}users`;
export const removeSystemUsersEndpoint = (id) => `${baseUrl}users/${id}`;

function serialize(obj) {
  return ('?' + Object.keys(obj).reduce((a, k) => {
    a.push(k + '=' + encodeURIComponent(obj[k]));
    return a;
  }, []).join('&'));
}




// WEBPACK FOOTER //
// ./src/services/endpoints.js